"use strict";

import InteractionView from "/js/interaction-views/interaction-view.js";

/** 
 * Interaction view that shows when interaction json uses an unknown template type
 * (for use during development).
 */
export default class UnsupportedInteractionView extends InteractionView {
  
  constructor(data, initialAnswers=null) {
    super(data, initialAnswers);

    const s = `
        <br><br><em>${this.data.interactionId}</em><br>
        template: ${this.data.template}<br><br>
        <button id='donebutton'>mock done</button>`;
    const content = $.parseHTML(s);
    this.$el.append(content);

    this.$el.find("#donebutton").click($.proxy(this.finish, this));
  }
}
